module.exports = "form .row {\n  margin-top: 1em; }\n\n.ng-valid[required], .ng-valid.required {\n  border-left: 5px solid #42A948;\n  /* green */ }\n\n.ng-touched.ng-invalid:not(form) {\n  border-left: 5px solid #a94442;\n  /* red */ }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/contact.component.scss
// module id = 238
// module chunks = 1